export const typography = {
  fontFamily: ['Nunito Sans', 'Helvetica', 'Arial', 'sans-serif'].join(','),
  fontSize: 16,
  h1: {
    // Should really be rem, but we also have the old sass overriding the html element
    fontSize: '96px',
  },
  h2: {
    fontSize: '60px',
  },
  h3: {
    fontSize: '48px',
  },
  h4: {
    fontSize: '34px',
  },
  h5: {
    fontSize: '24px',
  },
  h6: {
    fontSize: '20px',
  },
  caption: {
    fontSize: '12px',
  },
  subtitle1: {
    fontSize: '16px',
  },
  subtitle2: {
    fontSize: '14px',
  },
  body1: {
    fontSize: '15px',
    lineHeight: 1.45,
  },
  body2: {
    fontSize: '14px',
    lineHeight: 1.25,
  },
  button: {
    letterSpacing: '.46px',
    fontWeight: 400,
  },
};
